import { axiosInstance } from "@/apis/core";
import { IS_DEMO_MODE, demoBuildings, getDemoPlaces } from "@/dummy/demo";
import { pmcPlaceByFloor, ptonnuriPlaceByFloor } from "@/dummy/places";
import { classifyingPlace } from "@/utils/place";

const fallbackBuildings = [
  { bldCd: "PTK_PTK", bldNm: "본관", cpsCd: "PTK", delYn: "N" },
  { bldCd: "PTK_PMC", bldNm: "선교관", cpsCd: "PTK", delYn: "N" },
];

export const fetchBuilding = async () => {
  if (IS_DEMO_MODE) {
    return { data: demoBuildings };
  }

  try {
    const res = await axiosInstance.get(
      `/portal-service/api/v1/building/list?cpsCd=PTK`,
    );

    return res;
  } catch (error: unknown) {
    console.log("error : ", error);
    return { data: fallbackBuildings };
  }
};

export const fetchPlace = async (bldCd: string) => {
  if (IS_DEMO_MODE) {
    return getDemoPlaces();
  }

  try {
    const res = await axiosInstance.get(
      `/portal-service/api/v1/place/list?cpsCd=PTK&bldCd=${bldCd}`,
    );

    return classifyingPlace(res.data);
  } catch (error: unknown) {
    console.log("error : ", error);
    return bldCd === "PTK_PMC" ? pmcPlaceByFloor : ptonnuriPlaceByFloor;
  }
};

export type PlaceOption = { id: string; name: string };

// 층별로 그룹된 장소 목록을 Dropdown용 { id, name } 옵션으로 평탄화.
// includeAll이 true면 "전체" 옵션을 맨 앞에 추가한다.
export const fetchPlaceOptions = async (
  bldCd: string,
  { includeAll = false }: { includeAll?: boolean } = {},
): Promise<PlaceOption[]> => {
  const grouped = (await fetchPlace(bldCd)) ?? [];
  const options = grouped.flatMap((floor: any) =>
    floor.places.map((place: any) => ({ id: place.plcCd, name: place.plcNm })),
  );

  return includeAll ? [{ id: "all", name: "전체" }, ...options] : options;
};
